import { Directive, ElementRef, Input } from '@angular/core';

import * as _ from 'lodash';

@Directive({
  selector: 'text-color',
})
export class TextColorDirective {
  @Input('text-color') private set _setTextColor(newValue: string) {
    this._color = newValue || null;
    this._updateClasses();
  }

  constructor(
    public elementRef: ElementRef
  ) {}

  private _color: string;
  private _classes: Array<string> = [];

  private _updateClasses() {
    this._clearClasses();

    if (this._color) { this._classes.push(`text-${this._color}`); }

    this._setClasses();
  }

  private _clearClasses() {
    if (this._classes) {
      const current_classes = this.elementRef.nativeElement.className.split(' ');
      this._classes.forEach((_class) => {
        const index = current_classes.indexOf(_class);
        if (index > -1) { current_classes.splice(index, 1); }
      });
      this._classes = [];
      this.elementRef.nativeElement.className = current_classes.join(' ');
    }
  }

  private _setClasses() {
    const current_classes = this.elementRef.nativeElement.className.split(' ').filter((i) => !!i);
    this.elementRef.nativeElement.className = _.concat(current_classes, this._classes).join(' ');
  }
}
